(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["org-collection-list-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(section) {
    var viewport = section.querySelector('[data-cs-viewport]');
    var track = section.querySelector('[data-cs-track]');
    var prevBtn = section.querySelector('[data-cs-prev]');
    var nextBtn = section.querySelector('[data-cs-next]');
    if (!viewport || !track) return;

    // --cs-cols と --cs-gap-col を実測して、ちょうどN列だけ画面内に収まる
    // カード幅(px)を計算し、--cs-card-w に反映する。
    // これによりN+1枚目以降のカードは自動的に画面外へクリップされる。
    // ビューポートの左右paddingぶんを差し引き、端数は切り捨てて次カードの見切れを防ぐ。
    function recalcCardWidth() {
      var sectionStyles = getComputedStyle(section);
      var viewportStyles = getComputedStyle(viewport);
      var cols = parseFloat(sectionStyles.getPropertyValue('--cs-cols')) || 5;
      var gap = parseFloat(sectionStyles.getPropertyValue('--cs-gap-col')) || 16;
      var hPadding = parseFloat(viewportStyles.paddingLeft || 0) + parseFloat(viewportStyles.paddingRight || 0);
      var width = viewport.clientWidth - hPadding;
      var cardWidth = Math.floor((width - gap * (cols - 1)) / cols);
      if (cardWidth > 0) {
        section.style.setProperty('--cs-card-w', cardWidth + 'px');
      }
    }

    function updateNavState() {
      var maxScroll = track.scrollWidth - viewport.clientWidth;
      if (prevBtn) prevBtn.disabled = viewport.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = viewport.scrollLeft >= maxScroll - 4;
    }

    function goToPage(direction) {
      // 画面幅ぶん（= 現在の列数x2行ぶん）だけ送るが、
      // 端では0 / maxScrollに必ずぴったり収まるようJS側で明示的にクランプする。
      // （scrollByの相対移動だけだとスナップとの兼ね合いで端に戻り切らないことがあるため）
      var maxScroll = track.scrollWidth - viewport.clientWidth;
      var target = viewport.scrollLeft + direction * viewport.clientWidth;
      target = Math.max(100, Math.min(target, maxScroll));
      viewport.scrollTo({ left: target, behavior: 'smooth' });
    }

    prevBtn && prevBtn.addEventListener('click', function () { goToPage(-1); });
    nextBtn && nextBtn.addEventListener('click', function () { goToPage(1); });

    viewport.addEventListener('scroll', updateNavState, { passive: true });
    // smooth scrollのアニメーション完了後にも念のため再チェック
    viewport.addEventListener('scrollend', updateNavState, { passive: true });

    // リサイズ・ブレークポイント変化のたびにカード幅を再計算
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        recalcCardWidth();
        updateNavState();
      });
      ro.observe(viewport);
    } else {
      window.addEventListener('resize', function () {
        recalcCardWidth();
        updateNavState();
      });
    }

    recalcCardWidth();
    updateNavState();
  }

  function initAll() {
    document.querySelectorAll('.cs-section').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // テーマエディタでセクションを再読み込みした時にも初期化されるように
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.cs-section');
    if (section) initSlider(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["org-slider"] && !Shopify.designMode) return;
  try {
    
//トップスライダー
var slider = new Swiper ('.topSlider', {
	effect:'fade',
	speed: 1000,
	autoplay: {
        delay: 5000,
    },   
	spaceBetween: 1,
	slidesPerView: 1,
	centeredSlides: true,
	centerInsufficientSlides: true,
	loop: true,
	pagination: {
		el: '.swiper-pagination',
	},
	breakpoints: {
		961: {
			slidesPerView:1,
			spaceBetween: 20,
		},
		1441: {
			slidesPerView:1,
		},
		1601: {
			slidesPerView:1,
		},
	},
});

  } catch(e) { console.error(e); }
})();
})();
